import { render, staticRenderFns } from "./FileUploader.vue?vue&type=template&id=ed540f2e&scoped=true&"
import script from "./FileUploader.vue?vue&type=script&lang=js&"
export * from "./FileUploader.vue?vue&type=script&lang=js&"
import style0 from "./FileUploader.vue?vue&type=style&index=0&id=ed540f2e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed540f2e",
  null
  
)

export default component.exports